<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Preferences</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="save()"
        >Save</el-button
      >
      <el-button
        style="float: right; margin-right: 30px"
        @click="editForm = !editForm"
        >Edit</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-form
        v-if="form"
        ref="preferenesForm"
        :model="form"
        label-width="100px"
      >
        <h3 style="margin-left: 30px">Logo</h3>
        <el-form-item label="Logo" prop="Logo">
          <img v-if="!!form.logo" :src="form.logo" />
          <el-image
            v-if="!form.logo"
            style="width: 100%; height: 100%; display: flex; display: block"
          >
            <div slot="error" class="image-slot">
              <em class="el-icon-picture-outline"></em>
            </div>
          </el-image>
          <br />
          <input
            :disabled="!editForm"
            type="file"
            id="fileTitle"
            @change="loadFile()"
            ref="myFile"
          />
          <el-button
            :disabled="!editForm"
            type="danger"
            size="mini"
            @click="clearInput()"
            icon="el-icon-delete"
            circle
          ></el-button>
        </el-form-item>
        <el-form-item label="Company Name">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.companyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="Address">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.address"
          ></el-input>
        </el-form-item>
        <el-form-item label="Tax Number">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.taxNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="Telephone">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.telephone"
          ></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.email"
          ></el-input>
        </el-form-item>
        <el-form-item label="Web">
          <el-input
            :disabled="!editForm"
            placeholder="Please input"
            v-model="form.web"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Customer",
  data() {
    return {
      formLoading: false,
      showForm: false,
      editId: "",
      showMobileUserLimit: false,
      editForm: false,
      form: {
        logo: "",
        companyName: "",
        address: "",
        taxNumber: "",
        telephone: "",
        email: "",
        web: "",
      },
    };
  },
  created() {
    this.loadPartner().then(() => {
      this.form = JSON.parse(JSON.stringify(this.partner.preferences));
    });
  },
  computed: {
    ...mapState("partner", ["loading"]),
    ...mapState("account", ["partner"]),
  },
  watch: {
    "form.logo"() {
      this.$forceUpdate();
    },
  },
  methods: {
    ...mapActions("partner", ["updatePreferences"]),
    ...mapActions("account", ["loadPartner"]),

    save() {
      this.updatePreferences(JSON.parse(JSON.stringify(this.form)))
        .then(this.loadPartner())
        .then(() => {
          this.editForm = false;
          this.$message.success("Saved");
        });
    },
    clearInput() {
      this.form.logo = "";
      this.$refs.myFile.value = "";
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async loadFile() {
      let preURL = await this.toBase64(this.$refs.myFile.files[0]);
      this.form.logo = await this.resizeImage(preURL, 300, 40);
      let temporary = this.form.logo;
      this.form.logo = !this.form.logo;
      this.form.logo = temporary;
    },
    async resizeImage(base64Str, maxWidth, maxHeight) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          const MAX_HEIGHT = maxHeight;
          let width = img.width;
          let height = img.height;
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    },
  },
};
</script>
<style scoped>
.edit {
  opacity: 0;
}

.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>